export * from './AcademyDetails';
